import Cookies from 'js-cookie';

export const LAST_LOGGED_IN_USER_ID_KEY = 'lastLoggedInUserId';

const AUTH_COOKIE_NAMES = [
  'token',
  'refreshToken',
  'sessionId',
  'userId',
  'userRole',
  'userRoleId',
  'userDesignation',
  'userVertical',
  'userDesignationLevel',
  'userName',
  'userEmail',
  'domino_enabled'
];

function setAuthCookie(name, value) {
  if (value === undefined || value === null || value === '') {
    Cookies.remove(name);
    return;
  }
  Cookies.set(name, value);
}

export function saveAuthSessionCookies({
  token,
  refreshToken,
  sessionId,
  domino_enabled,
  user
} = {}) {
  // Always wipe the previous session first so stale vertical/level cookies
  // from another user (or an old role) cannot leak into the new login.
  clearAuthSession();

  setAuthCookie('token', token);
  setAuthCookie('refreshToken', refreshToken);
  setAuthCookie('sessionId', sessionId);
  setAuthCookie('userRoleId', user?.role?.id);
  setAuthCookie('userId', user?.id);
  setAuthCookie('userDesignation', user?.designation?.name);
  setAuthCookie('userRole', user?.role?.name);
  setAuthCookie('userVertical', user?.vertical);
  setAuthCookie('userDesignationLevel', user?.level);
  if (domino_enabled !== undefined && domino_enabled !== null) {
    Cookies.set('domino_enabled', String(domino_enabled));
  }
}

export function isDominoEnabled() {
  return Cookies.get('domino_enabled') !== 'false';
}

export function getSessionVertical() {
  return String(Cookies.get('userVertical') || '').toLowerCase();
}

export function getSessionLevel() {
  return Cookies.get('userDesignationLevel');
}

/** Sales vertical, Manager level (Medium) — e.g. Chanpreet. */
export function isSalesManagerSession(user = null) {
  const vertical = user?.vertical ?? Cookies.get('userVertical');
  const level = user?.level ?? Cookies.get('userDesignationLevel');
  return String(vertical || '').toLowerCase() === 'sales' && level === 'Medium';
}

export function isSalesVerticalSession(user = null) {
  const vertical = user?.vertical ?? Cookies.get('userVertical');
  return String(vertical || '').toLowerCase() === 'sales';
}

export function isManagementVerticalSession(user = null) {
  const vertical = user?.vertical ?? Cookies.get('userVertical');
  return String(vertical || '').toLowerCase() === 'management';
}

/** Reconcile profile cookies with the server user record (fixes stale vertical/level). */
export function syncSessionProfileFromUser(user) {
  if (!user) return false;

  const profile = {
    userRoleId: user?.role?.id,
    userDesignation: user?.designation?.name,
    userRole: user?.role?.name,
    userVertical: user?.vertical ?? user?.designation?.vertical,
    userDesignationLevel: user?.level
  };

  let changed = false;
  Object.entries(profile).forEach(([name, value]) => {
    const next = value == null ? '' : String(value);
    const current = Cookies.get(name) || '';
    if (next !== current) {
      setAuthCookie(name, value);
      changed = true;
    }
  });

  return changed;
}

export function clearAuthSession() {
  AUTH_COOKIE_NAMES.forEach((name) => Cookies.remove(name));
  localStorage.removeItem('accessToken');
}

export function clearUserPreferences() {
  localStorage.clear();
}

export function handlePostLoginStorage(newUserId) {
  if (newUserId == null) return;

  const newUserIdStr = String(newUserId);
  const previousUserId = localStorage.getItem(LAST_LOGGED_IN_USER_ID_KEY);
  const previousCookieUserId = Cookies.get('userId');

  if (
    (previousUserId && previousUserId !== newUserIdStr) ||
    (previousCookieUserId && previousCookieUserId !== newUserIdStr)
  ) {
    clearUserPreferences();
  }

  localStorage.setItem(LAST_LOGGED_IN_USER_ID_KEY, newUserIdStr);
}

export function handleLogoutStorage() {
  clearAuthSession();
  clearUserPreferences();
}
